import React, { useRef, useCallback, useEffect, useState } from 'react';
import { useField } from '@unform/core';
import * as S from './styles';

type Props = JSX.IntrinsicElements['input'] & {
  name: string;
  id?: string;
  label?: string;
  placeholder?: string;
  isLoading?: boolean;
  classContainer?: string;
};

export const Input: React.FC<Props> = ({
  name,
  id,
  label,
  type,
  placeholder = ' ',
  isLoading = false,
  classContainer = '',
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);
  const [passwdVisible, setPasswdVisible] = useState<boolean>(false);
  const [tempType, setTempType] = useState(type);

  const togglePasswordVisibility = useCallback((): void => {
    setPasswdVisible((value) => !value);
    if (inputRef.current) {
      inputRef.current.type === 'password'
        ? (inputRef.current.type = 'text')
        : (inputRef.current.type = 'password');
    }
  }, []);

  const LabelComponent = useCallback((): JSX.Element => {
    if (!label) return <></>;
    return <S.FieldLabel htmlFor={id || fieldName}>{label}</S.FieldLabel>;
  }, [fieldName, id, label]);

  const ErrorComponent = useCallback((): JSX.Element => {
    if (!error) return <></>;
    return <S.FieldError>{error}</S.FieldError>;
  }, [error]);

  useEffect(() => {
    registerField({
      name: fieldName,
      path: 'value',
      ref: inputRef.current,
    });
  }, [fieldName, registerField]);

  if (type === 'hidden') {
    return (
      <input
        name={fieldName}
        id={id || fieldName}
        ref={inputRef}
        defaultValue={defaultValue}
        type={type}
        {...rest}
      />
    );
  }

  const handleFocusDateType = () => {
    if (type === 'date') {
      setTempType('date');
    }
  };

  const handleBlurDateType = () => {
    if (type === 'date' && !inputRef.current?.value) {
      setTempType('text');
    }
  };

  return (
    <S.Container
      className={
        classContainer ? `field-container ${classContainer}` : 'field-container'
      }
    >
      <LabelComponent />
      <S.RelativeWrapper>
        <input
          name={fieldName}
          id={id || fieldName}
          ref={inputRef}
          defaultValue={defaultValue}
          placeholder={placeholder}
          type={tempType}
          onFocus={handleFocusDateType}
          onBlur={handleBlurDateType}
          {...rest}
        />
        {isLoading && (
          <S.ActivityIndicatorContainer>
            <S.ActivityIndicator />
          </S.ActivityIndicatorContainer>
        )}
        {type === 'password' && (
          <S.PasswdToggler
            title={passwdVisible ? 'Ocultar senha' : 'Mostrar senha'}
            onClick={togglePasswordVisibility}
          >
            {passwdVisible ? <S.EyeOffIcon /> : <S.EyeIcon />}
          </S.PasswdToggler>
        )}
      </S.RelativeWrapper>
      <ErrorComponent />
    </S.Container>
  );
};
